import { render, staticRenderFns } from "./EmploymentStatusModal.vue?vue&type=template&id=5fb9621d"
import script from "./EmploymentStatusModal.vue?vue&type=script&lang=js"
export * from "./EmploymentStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports